import { get } from "lodash"
import { createSelector } from "reselect"
import { getMostUsedOrDefaultModelId } from "helpers/models"
import { getModels } from "resources/models"

const EMPTY_ARRAY = []

const getPortfolios = state => get(state, "global.data.portfolios.data", EMPTY_ARRAY)
export const getSelectedModel = state => get(state, "modules.homeLayout.selectedModelId")

const getDefaultModel = createSelector(
  [getPortfolios, getModels],
  getMostUsedOrDefaultModelId,
)

export const getModel = createSelector(
  [getSelectedModel, getDefaultModel],
  (selectedModel, defaultModel) => {
    return selectedModel || defaultModel
  },
)
